import React, { useEffect, useState, useRef } from 'react';
export function HeroSection() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);
  const scrollToCTA = () => {
    document.getElementById('cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const scrollToMethod = () => {
    document.getElementById('method')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center pt-16 overflow-hidden" style={{
    backgroundColor: '#0F2540'
  }} data-id="element-82">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-83">
        <div className="absolute inset-0" style={{
        backgroundImage: `repeating-linear-gradient(
              45deg,
              #C9A84C 0px,
              #C9A84C 1px,
              transparent 1px,
              transparent 60px
            )`
      }} data-id="element-84" />
      </div>

      {/* Radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full opacity-10" style={{
      background: 'radial-gradient(circle, #C9A84C 0%, transparent 70%)'
    }} data-id="element-85" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-16 lg:py-24 w-full" data-id="element-86">
        <div className="grid lg:grid-cols-5 gap-12 items-center" data-id="element-87">
          {/* Left content */}
          <div className="lg:col-span-3 transition-all duration-1000" style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(30px)'
        }} data-id="element-88">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-body font-bold mb-6 tracking-wide" style={{
            backgroundColor: 'rgba(201,168,76,0.15)',
            border: '1px solid rgba(201,168,76,0.4)',
            color: '#E2C97E'
          }} data-id="element-89">
              <span data-id="element-90">✦</span>
              <span data-id="element-91">Para mujeres de +45 que se niegan a quedar obsoletas</span>
              <span data-id="element-92">✦</span>
            </div>

            {/* Main headline */}
            <h1 className="font-heading font-black leading-tight mb-4" style={{
            color: '#FAF7F2',
            fontSize: 'clamp(2rem, 5vw, 3.5rem)'
          }} data-id="element-93">
              Deja de enviar CVs
              <br data-id="element-94" />
              <span className="gold-shimmer" data-id="element-95">a agujeros negros</span>
            </h1>

            {/* Subheadline */}
            <p className="font-heading italic text-xl mb-6 leading-relaxed" style={{
            color: '#C9A84C'
          }} data-id="element-96">
              El método para ser contratada por tu criterio,
              <br data-id="element-97" />
              no por tu edad.
            </p>

            {/* Body */}
            <p className="font-body text-lg leading-relaxed mb-8 max-w-xl" style={{
            color: '#C8D8E8'
          }} data-id="element-98">
              Mientras el mercado laboral te ignora, hay miles de emprendedores
              digitales{' '}
              <strong style={{
              color: '#E2C97E'
            }} data-id="element-99">
                desesperados por encontrar a alguien como tú
              </strong>
              . Tu experiencia no es un lastre. Es tu activo más valioso.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-100">
              <button onClick={scrollToCTA} className="btn-gold-pulse px-8 py-4 rounded font-body font-black text-base tracking-wide transition-all duration-200 hover:scale-105 hover:brightness-110" style={{
              backgroundColor: '#C9A84C',
              color: '#0F2540'
            }} data-id="element-101">
                Descubre el Método Fénix →
              </button>
              <button onClick={scrollToMethod} className="px-8 py-4 rounded font-body font-bold text-base tracking-wide transition-all duration-200 hover:bg-white/10" style={{
              border: '2px solid rgba(201,168,76,0.5)',
              color: '#E2C97E'
            }} data-id="element-102">
                Ver cómo funciona ↓
              </button>
            </div>

            {/* Trust badges */}
            <div className="flex flex-wrap gap-4" data-id="element-103">
              {[{
              icon: '🔒',
              text: 'Sin algoritmos de RRHH'
            }, {
              icon: '💻',
              text: '100% desde casa'
            }, {
              icon: '⭐',
              text: '+20 años = tu ventaja'
            }].map(badge => <div key={badge.text} className="flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-body" style={{
              backgroundColor: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(255,255,255,0.12)',
              color: '#C8D8E8'
            }} data-id="element-104">
                  <span data-id="element-105">{badge.icon}</span>
                  <span data-id="element-106">{badge.text}</span>
                </div>)}
            </div>
          </div>

          {/* Right: Product image */}
          <div className="lg:col-span-2 flex justify-center lg:justify-end transition-all duration-1000 delay-300" style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0) rotate(0deg)' : 'translateY(40px) rotate(3deg)'
        }} data-id="element-107">
            <div className="relative" data-id="element-108">
              {/* Glow behind image */}
              <div className="absolute inset-0 rounded-2xl blur-2xl opacity-40 scale-95" style={{
              backgroundColor: '#C9A84C'
            }} data-id="element-109" />
              <img src="https://cdn.magicpatterns.com/uploads/7UFTU8fCrbNzfGX96cBi47/metodo_fenix.png" alt="El Método Fénix 45+ - De invisible a imprescindible en 30 días" className="relative rounded-2xl shadow-2xl w-full max-w-sm lg:max-w-full" style={{
              border: '2px solid rgba(201,168,76,0.4)',
              transform: 'rotate(2deg)'
            }} data-id="element-110" />
              {/* Floating badge */}
              <div className="absolute -bottom-4 -left-4 px-4 py-3 rounded-xl font-body font-bold text-sm shadow-xl" style={{
              backgroundColor: '#C9A84C',
              color: '#0F2540',
              transform: 'rotate(-3deg)'
            }} data-id="element-111">
                De invisible a imprescindible
                <br data-id="element-112" />
                <span className="font-black" data-id="element-113">en 30 días</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gold divider */}
      <div className="absolute bottom-0 left-0 right-0 gold-divider" data-id="element-114" />
    </section>;
}